<template>
  <div
    class="skeleton-side-bar pa-6 pb-3"
  >
    <div class="w-100 d-flex ga-8">
      <ScoreMeterSkeletonLoader
        class="score-meter opacity-50"
        :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
      />

      <div>
        <v-skeleton-loader
          type="heading"
          width="145px"
          class="mt-5 skeleton-sub-heading"
          :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
          />
        <v-skeleton-loader
          type="heading"
          width="116px"
          class="mt-1 skeleton-sub-heading"
          data-testid="second"
          :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
          />
      </div>
    </div>

    <div
      v-for="(_, i) in Array(4)"
      :key="i"
      class="mt-6 w-100"
      :class="{ show: animationIndex > 2, hide: animationIndex <= 2 }"
      data-testid="third"
    >
      <v-skeleton-loader
        type="heading"
        width="203px"
        class="ml-4 w-100"
      />
    </div>
  </div>
</template>

<script>
import ScoreMeterSkeletonLoader from '@/components/shared/SkeletonLoaders/ScoreMeterSkeletonLoader.vue';

export default {
  name: 'SidebarSkeleton',
  components: {
    ScoreMeterSkeletonLoader,
  },
  props: {
    animationIndex: { type: Number, default: 0 },
  },
};
</script>

<style scoped lang="less">
.skeleton-sub-heading :deep(.v-skeleton-loader__heading) {
  height: 20px;
}

.score-meter {
  transform: scale(0.7);
}

.hide {
  opacity: 0;
}

.show {
  animation: fadeIn .25s;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
</style>
